<template>
  <NuxtLayout name="standard">
    <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OTHERS" />
    <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.OTHERS" />

    <SSection
      :title="t('landings.villages-list.title')"
      :has-separator="false"
      title-tag="h1"
    >
      <TText size="lg" classes="mb-7">
        {{ t('landings.villages-list.description') }}
      </TText>
      <SLinks v-bind="sLinksPropsInterface"></SLinks>
    </SSection>

    <SSpacer />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Composables
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import type { propsInterface as SLinksPropsInterface } from '~~/modules/design-system/sections/s-links/s-links.vue'

// APIs
import getVillagesList from '~~/modules/api/strapi/pueblos-landings/list'

// Transformers
import { useToSLinks } from '~/composables/transformers/useToSLinks'

const { setHeadInfo } = useHeadInfoComposable()
const { fromStrapiVillagesList } = useToSLinks()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const sLinksPropsInterface: SLinksPropsInterface = {
  items: [],
  col: 2,
}

const dataApiList = await getVillagesList()

if (dataApiList.success) {
  setHeadInfo({
    title: t('landings.villages-list.seo.title'),
    description: t('landings.villages-list.seo.description'),
    robotsVisible: true,
  })

  const breadCrumbMenuStore = useMenuBreadcrumbStore()
  breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.villages'))

  sLinksPropsInterface.items = fromStrapiVillagesList({
    dataIn: dataApiList.success.data,
  }).items
} else if (dataApiList.error) {
  showErrorPage(dataApiList.error as ApiResponseError)
}

sendConnectifPage()
</script>
